import React, { Component } from "react";
import { connect } from "react-redux";
import "./style.scss";
import classNames from "classnames";
import Modal from "../Modal";
import Heading from "../../elements/heading";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { withRouter } from "react-router-dom";
import { generateReactKey } from "../../utils/reactKey";
import countriesQuery from "../../Graphql/queryCountries";
import api from "../../utils/api";
import { setShowRegionModal } from "../../redux/actions/actions";

let countries = {};
class RegionModal extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      options: []
    };
  }
  componentDidMount() {
    this.setOptions();
  }
  isCurrentRegions(region) {
    if (this.props.lang.indexOf("-") > -1) {
      let cuy = this.props.lang.split("-")[1];
      return cuy.toLowerCase() === region.toLowerCase();
    } else {
      return this.props.lang.toLowerCase() === region.toLowerCase();
    }
  }
  isCurrentLanguage(region, language) {
    if (this.props.lang.indexOf("-") > -1) {
      let cuy = this.props.lang.split("-")[1];
      let lag = this.props.lang.split("-")[0];
      return cuy.toLowerCase() === region.toLowerCase() && lag.toLowerCase() === language.toLowerCase();
    } else {
      return this.props.lang === language.toLowerCase();
    }
  }

  async getCountries(p) {
    if (countries.hasOwnProperty(p)) {
      return countries[p];
    } else {
      const query = countriesQuery(p);
      const result = await api.graphql(null, { query: query });
      const data = result.data.countries?.children;
      countries[p] = data;
      return data;
    }
  }
  async setOptions() {
    const { fields = {} } = this.props,
      { regions } = fields;
    let _options = [];
    if (regions?.fields?.regions) {
      _options = await Promise.all(
        regions.fields.regions.map(async (item, index) => {
          let { country, language } = item.fields;
          let cn = country?.fields?.phrase?.value;
          let regin = {
            country: country?.fields?.key?.value,
            current: this.isCurrentRegions(cn || "en"),
            languages: []
          };

          let r = await Promise.all(
            language.map(async lang => {
              let ln = lang.fields?.phrase && lang.fields.phrase.value.toLowerCase();
              let langs = {
                language: lang.fields?.key && lang.fields?.key.value,
                link: (cn && `/${ln}-${cn.toLowerCase()}/`) || `/${ln}/`,
                current: this.isCurrentLanguage(cn || "en", ln || "en"),
                countryName: regin.country
              };
              if (language.length > 1) {
                let _lang = (cn && `${ln}-${cn}`) || `${ln}`;
                const _langCountries = await this.getCountries(_lang);
                const _countryName = _langCountries.filter(c => {
                  return c.phrase?.value?.toLowerCase() === cn?.toLowerCase();
                })[0].key.value;
                langs.countryName = _countryName;
              }
              //regin.languages.push(langs);
              return langs;
            })
          );
          regin.languages = r;
          return regin;
        })
      );
      this.setState({
        options: _options
      });
    }
  }
  closeRegionModal() {
    let elem = document.getElementById("regionModalId");

    if (elem && elem.classList.contains("show-modal")) {
      elem.classList.add("hide-modal");
      elem.classList.remove("show-modal");
      document.body.classList.remove("show-modal");
    }

    this.props.setShowRegionModal(false);
  }

  render() {
    if (!this.props.fields) return null;

    const { fields } = this.props,
      { paddingAboveTop, paddingAboveBottom, componentPadding, overlineText, headingType, headingBody, body, infoHeadingBody, infoHeadingType, infoBody, regions } = fields;
    const regionModalClasses = classNames("region-modal", componentPadding);

    let paddingClass = paddingAboveTop ? "padding-top-" + paddingAboveTop.fields.phrase.value : "";
    paddingClass += paddingAboveBottom ? " padding-bottom-" + paddingAboveBottom.fields.phrase.value : "";

    return (
      <Modal className={regionModalClasses} padding={paddingClass} id={"regionModalId"} onCloseClicked={evt => this.closeRegionModal()} showModal={this.props.showRegionModal}>
        {overlineText != null && <RichText tag="span" className="overline" field={overlineText} />}

        <Heading
          {...{
            type: headingType ? headingType : { fields: { key: { value: "h2" }, phrase: { value: "h2" } } },
            html: headingBody
          }}
          className={"title"}
        />

        {body != null && <RichText tag="p" field={body} />}
        <div className={"regions-container"}>
          {this.state.options != null &&
            this.state.options.map((region, index) => {
              const regionClasses = classNames("region", {
                current: region.current
              });
              return (
                <React.Fragment key={generateReactKey()}>
                  {region.languages &&
                    region.languages.map((language, lindex) => {
                      const languageClasses = classNames("language", {
                        current: language.current
                      });
                      return (
                        <div className={regionClasses} key={`${index}${lindex}`}>
                          <a className={languageClasses} key={lindex} href={language.link}>
                            <span className="text">{language.countryName || "Global"}</span>
                            <span className="bar">|</span>
                            <span className="text">{language.language}</span>
                          </a>
                        </div>
                      );
                    })}
                </React.Fragment>
              );
            })}
        </div>
        {infoHeadingBody && (
          <div className="info">
            <Heading
              {...{
                html: infoHeadingBody,
                type: infoHeadingType
              }}
            />
            {infoBody && <RichText tag="p" field={infoBody} />}
          </div>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  showRegionModal: state.showRegionModal
});

const mapDispatchToProps = dispatch => ({
  setShowRegionModal: data => dispatch(setShowRegionModal(data))
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RegionModal));

//export default GraphQLData(regionsQuery, { name: "GraphqlResult" })(
//  withRouter(RegionModal)
//);
